import { useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@mui/material';

import { BrandPage } from './brand-page';
import brandImage from '../../../../assets/images/brand-pages/ao1dmax-mf-30-front-new-3.png';
import brandImageMobile from '../../../../assets/images/brand-pages/ao1dmax-mf-30-front-new-mobile.png';
import eye from '../../../../assets/images/brand-pages/eye.svg';

export const BrandPageVision = (): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const intl = useIntl();

  return (
    <BrandPage
      title={intl.formatMessage(
        { id: 'brandPages.trust.title' },
        { sup: (chunks: React.ReactNode) => <sup>{chunks}</sup> },
      )}
      brandImage={isMobile ? brandImageMobile : brandImage}
      topIcon={eye}
      description={intl.formatMessage(
        { id: 'brandPages.trust.details' },
        {
          linebreak: !isMobile && <br />,
          sup: (chunks: React.ReactNode) => <sup>{chunks}</sup>,
        },
      )}
      legal={intl.formatMessage(
        { id: 'brandPages.trust.description' },
        { sup: (chunks: React.ReactNode) => <sup>{chunks}</sup> },
      )}
    />
  );
};
